export function invalid() {
  return I18n.t("errors.messages.invalid");
}

export function presence(value) {
  if (Array.isArray(value)) {
    if (value.length > 0) {
      return;
    }
  } else if (value !== "" && value !== null && value !== undefined) {
    return;
  }
  return I18n.t("errors.messages.empty");
}

export function inclusion(value, array) {
  if (array.includes(value)) {
    return I18n.t("errors.messages.inclusion");
  }
}

export function exclusion(value, array) {
  if (array.includes(value)) {
    return I18n.t("errors.messages.exclusion");
  }
}

export function length(value, options) {
  if (value === null || value === undefined) {
    return;
  }
  if (options.maximum && value.length > options.maximum) {
    return I18n.t("errors.messages.too_long", { count: options.maximum });
  }
  if (options.minimum && value.length < options.minimum) {
    return I18n.t("errors.messages.too_short", { count: options.minimum });
  }
  if (options.is && value.length !== options.is) {
    return I18n.t("errors.messages.wrong_length", { count: options.is });
  }
}

export function range(value, options) {
  if (value === null || value === undefined) {
    return;
  }

  if (options.greater_than !== undefined && value <= options.greater_than) {
    return I18n.t("errors.messages.greater_than", { count: options.greater_than });
  }

  if (options.greater_than_or_equal_to !== undefined && value < options.greater_than_or_equal_to) {
    return I18n.t("errors.messages.greater_than_or_equal_to", { count: options.greater_than_or_equal_to });
  }

  if (options.equal_to !== undefined && value !== options.equal_to) {
    return I18n.t("errors.messages.equal_to", { count: options.equal_to });
  }

  if (options.less_than !== undefined && value >= options.less_than) {
    return I18n.t("errors.messages.less_than", { count: options.less_than });
  }

  if (options.less_than_or_equal_to !== undefined && value > options.less_than_or_equal_to) {
    return I18n.t("errors.messages.less_than_or_equal_to", { count: options.less_than_or_equal_to });
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/validators.js